import React from 'react';
import Table from '../../component/table/table'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Pagination from '@material-ui/lab/Pagination';
import { MDBContainer,  MDBRow, MDBCol} from "mdbreact";
import './occasions.css'
import {message,TreeSelect,DatePicker,ConfigProvider} from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import { withRouter,Redirect} from 'react-router-dom'
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import moment from 'moment';
import { CSVLink } from "react-csv";
import 'moment/locale/ar';
import {SearchOutlined} from '@ant-design/icons';
import locale_ar from 'antd/lib/locale/ar_EG';
import locale_en from 'antd/lib/locale/en_GB';
const { RangePicker } = DatePicker;
const { TreeNode } = TreeSelect;
//const { SHOW_PARENT } = TreeSelect;
let headers = [
  { label: "#", key: "id" },
  { label: "Name", key: "name" },
  { label: "Type", key: "type" },
  { label: "Owner", key: "owner" },
  { label: "Owner Phone", key: "ownerPhone" },
  { label: "Date", key: "date" },
  { label: "End", key: "end" },
];
 
let csvData = [
  
];
// eslint-disable-next-line no-unused-vars
let startDate,endDate;
class occasions extends React.Component {
  
  state={
    occasions:[],
    occasions2:[],
    loading:true,
    refresh:false,
    page:1,
    pages:1,
    filterType:{},
    csvData:[],
    value:'',
    count:0,
    type:null,
    end:null,
    search:null,
    startDate:null,
    endDate:null,
    owner:this.props.location.state?this.props.location.state.owner:null
  }

  constructor(props){
    super(props)
    window.scrollTo(0,0)
    this.onChange = this.onChange.bind(this);
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }

  componentDidMount(){
    this.getOccasions(1,false)
    this.getOccasionsWithoutPagenation()
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }

  /**
  * get data with pagenation request 
  */
  getOccasions = (page,refresh,rest) =>{
    this.setState({loading:true})
    let {end,search,type,owner,startDate,endDate} = this.state
    let url = `${BASE_END_POINT}occasions?page=${page}`
    if(end !== null){
      let str = '&end='+ end
      url += str
    }
   
    if(type !== null){
      let str = '&type='+ type
      url += str
    }
    if(search !== null){
      let str = '&search='+ search
      url += str
    }
    if(owner !== null){
      let str = '&owner='+ owner
      url += str
    }
    if(startDate !== null && endDate !== null){
      let str = '&startDate='+ startDate+'&endDate=' + endDate
      url += str
    }
    if(rest) url = `${BASE_END_POINT}occasions`
    console.log(url)
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("occasions   ",response.data)
      var data = response.data.data.map(item=>[
        item.id,
        item.name,
        item.img?{type:"img",img:item.img}:{type:"img",img:null},
        item.type==="PRIVATE"?{type:'tag',value:allStrings.private}:{type:'tag',value:allStrings.public} ,
        item.owner?item.owner.fullname?item.owner.fullname:"":"",
        item.fullDate?moment(item.fullDate).format('ll'):"",
        item.end?{type:'tag',value:allStrings.yes}:{type:'tag',value:allStrings.no} ,

        "action"])
      console.log("DATA   ",data)
      this.setState({
        loading:false,
        refresh:false,
        occasions:response.data.data,
        occasions2:data,
        page:response.data.page,
        pages:response.data.pageCount,
      })
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
      this.setState({loading:false,})
    })
  }
  /**
  * get data without pagenation request 
  */
  getOccasionsWithoutPagenation = (rest) =>{
    let url = `${BASE_END_POINT}occasions/withoutPagenation/get`
    let {end,search,type,owner,startDate,endDate} = this.state
    if(end !== null){
      let str = '&end='+ end
      url += str
    }
   
    if(type !== null){
      let str = '&type='+ type
      url += str
    }
    if(search !== null){
      let str = '&search='+ search
      url += str
    }
    if(owner !== null){
      let str = '&owner='+ owner
      url += str
    }
    if(startDate !== null && endDate !== null){
      let str = '&startDate='+ startDate+'&endDate=' + endDate
      url += str
    }
    if(rest) url = `${BASE_END_POINT}occasions/withoutPagenation/get`
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("USERS   ",response.data.data)
        csvData= response.data.data.map(item => {
          return {
            ...{id:item.id},
            ...{name:item.name},
            ...{type:item.type==="PRIVATE"?allStrings.private:allStrings.public},
            ...{owner:item.owner?item.owner.fullname?item.owner.fullname:"":""},
            ...{ownerPhone:item.owner?item.owner.phone?item.owner.phone:"":""},
            ...{date:item.fullDate?moment(item.fullDate).format('ll'):""},
            ...{end:item.end?allStrings.yes:allStrings.no},
          };
        });
        console.log(csvData)
        this.setState({csvData:csvData})
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
    })
  }
  /**
  * delete request 
  */

  delete = (id) => {
    console.log("ID   ",id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}occasions/${id}`,{
     headers: {
       'Content-Type': 'application/json',
       'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
     },
    })
    .then(response=>{
      l.then(() => message.success(allStrings.done, 2.5) )
      this.getOccasions(this.state.page)
    })
    .catch(error=>{
        console.log(error.response)
        l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
    })
 }
  /**
  * pagination Buttons component
  */
  paginationButtons = () =>(
    <CardActions style={{display: 'inline-flex'}}>
        <Button 
        onClick={()=>{
          if(this.state.page!==1){
            this.getOccasions(1)
            this.setState({page:1})
          }
        }}
        className="pagenation" >{allStrings.first}</Button>

        <Button 
        onClick={()=>{
         if(this.state.page>1){
            this.getOccasions(this.state.page-1)
            this.setState({page:this.state.page-1})
         }
        }}
        className="pagenation">{allStrings.prev}</Button>
        
        <Pagination
        onChange={(event,page)=>{
        console.log("page   ",page)
        if(page!==this.state.page){
          this.getOccasions(page)
          this.setState({page:page})
        }
        
        }} 
        defaultPage={1} page={this.state.page} count={this.state.pages} style={{color:`#117183 !important`}} />
        
        <Button 
        onClick={()=>{
          if(this.state.page<this.state.pages){
            this.getOccasions(this.state.page+1)
            this.setState({page:this.state.page+1})
          }
        }}
        className="pagenation">{allStrings.next}</Button>

        <Button 
         onClick={()=>{
          if(this.state.page!==this.state.pages){
            this.getOccasions(this.state.pages)
            this.setState({page:this.state.pages})
          }
        }}
        className="pagenation">{allStrings.last}</Button>

    </CardActions>
  )
  onChange(dates, dateStrings) {
    console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
    if(this.props.isRTL){
      this.setState({
        startDate:moment(dateStrings[0]).locale('en').format("YYYY-MM-DD"),
        endDate:moment(dateStrings[1]).locale('en').format("YYYY-MM-DD"),
      })
    }else{
      this.setState({
        startDate:moment(dateStrings[0]).locale('en').format("YYYY-MM-DD"), 
        endDate:moment(dateStrings[1]).locale('en').format("YYYY-MM-DD"),
      })
    }
    startDate = moment(dateStrings[0]).locale('en').format("YYYY-MM-DD")
    endDate = moment(dateStrings[1]).locale('en').format("YYYY-MM-DD")
  }
  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('OCCASIONS')) return <Redirect to='/Home' />

  return (
    <div className="App">
        
      <MDBContainer> 
      <MDBRow>
        <MDBCol md="12">
          <div className="screenTable">
          <Table
          /**table settings contain reload and csv  */
            settings = {
              <div>
                <i class="fab fa-searchengin searchIcon" onClick={()=>this.setState({showFilter:!this.state.showFilter})}></i>
                <span 
                style={{position: 'relative',padding: '4px',color: '#659FF1',fontSize: '25px',borderRadius:'50%',top:'4px',cursor: 'pointer'}}
                onClick={() => {this.setState({end:null,type:null,search:null});this.getOccasions(1,false,true);this.getOccasionsWithoutPagenation(true)}}
                class="material-icons">
                  replay
                </span>
                <CSVLink 
                  data={this.state.csvData} 
                  headers={headers} 
                  filename={"occasions.csv"}
                  style={{padding: '10px',position: 'relative',top: '-5px'}}
                  >
                  <img alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
                </CSVLink>
              </div>
              
            }
            /**table filter  */
            filter ={
              <div>
                <div className={this.state.showFilter?'showClass':'hideClass'} style={{height:this.state.showFilter?"250px":"0px"}}>
                  <MDBRow>
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                      <div class="md-form">
                      <label htmlFor="form605" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.Search}</label>
                      <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',fontWeight:'300'}} type="text" id="form605"  class="form-control"
                        placeholder={allStrings.occasionSearch}
                        onChange={(e)=>{
                          this.setState({search:e.target.value})
                        }}  
                      />
                      </div>
                    </MDBCol>
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                        <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.end}</label>
                        <TreeSelect virtual={false}
                          showSearch={false}
                          value={this.state.end}
                          style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',minHeight:'35px',marginBottom:'1rem'}} 
                          treeCheckable = {false}         
                          treeNodeFilterProp="title"                      
                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                          placeholder={allStrings.end}
                          onChange={(value) => {
                          console.log(value)
                          this.setState({end:value});
                          }} 
                      
                      >
                          <TreeNode value="true" title={allStrings.yes} key="true" />
                          <TreeNode value="false" title={allStrings.no} key="false" />
                        
                      </TreeSelect>
                    </MDBCol>
                    
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.type}</label>
                      <TreeSelect virtual={false}
                          showSearch={false}
                          value={this.state.type}
                          style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',minHeight:'35px',marginBottom:'1rem'}} 
                          treeCheckable = {false}         
                          treeNodeFilterProp="title"                      
                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                          placeholder={allStrings.type}
                          onChange={(value) => {
                          console.log(value)
                          this.setState({type:value});
                          }} 
                      
                      >
                          <TreeNode value="PRIVATE" title={allStrings.private} key="PRIVATE" />
                          <TreeNode value="PUBLIC" title={allStrings.public} key="PUBLIC" />
                        
                      </TreeSelect>
                    </MDBCol>
                    <MDBCol xl="4" lg="4" md="4" sm="12"></MDBCol>
                    <MDBCol xl="4" lg="4" md="4" sm="12"></MDBCol>
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                      <label htmlFor="form605" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.date}</label>
                      <ConfigProvider locale={this.props.isRTL?locale_ar:locale_en}>
                        <RangePicker style={{width:"100%"}} format={"YYYY-MM-DD"} placeholder={[allStrings.startDate,allStrings.endDate]} onChange={this.onChange} />
                      </ConfigProvider>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                  <MDBCol md="12">
                    <Button style={{background: '#117183',color: '#fff',width: '100%',margin: '32px auto'}} 
                      onClick={()=>{this.getOccasions(1);this.getOccasionsWithoutPagenation()}}><SearchOutlined /> {allStrings.Search}</Button>
                    </MDBCol>
                  </MDBRow>
                  
                </div>
              </div>
            }
            title={allStrings.occasions}
            icon='event'
            data={this.state.occasions}
            data2={this.state.occasions2}
            tableColumns={["#",allStrings.name,allStrings.img,allStrings.type,allStrings.owner,allStrings.date,allStrings.end,allStrings.action]}
            loading={this.state.loading}
            deleteUser={(id)=>{this.delete(id)}}
            path='/occasionInfo'
            enableEdit={false}
            actionIndex={6}
            />
            {this.paginationButtons()}
            </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </div> 
  )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  ChangeLanguage
}

export default  withRouter(
  connect(mapToStateProps,mapDispatchToProps)(occasions)
);

